(function ($) {
    'use strict';

    window._define('common', function () {

        return {
            init: function () {
                $('[data-dismiss]').on('click', function () {
                    $(this).parent('div').remove();
                });
            },
        };
    });

})(window.jQuery);
